var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1000003161(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 144,
    viewBox: "0 0 221 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.5 144C126.608 144 125 142.923 125 141.657V74.343C125 73.0765 126.608 72 128.5 72C130.392 72 132 73.0765 132 74.343V141.657C132 142.923 130.392 144 128.5 144Z",
    fill: "#2181FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M195 88.9004H65.5V54.4004C65.5 38.2004 78.8 24.9004 95 24.9004H165.4C181.6 24.9004 194.9 38.2004 194.9 54.4004V88.9004H195Z",
    fill: "#2181FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.2 83.2016C122.2 83.1016 122.2 83.1016 122.2 83.0016V56.9016C122.2 41.9016 110.7 29.6016 96.6 29.6016C82.5 29.6016 71 41.9016 71 56.9016V83.0016C71 83.1016 71 83.1016 71 83.2016H122.2Z",
    fill: "#0856B7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M192.306 88.9008H60.6062C59.1062 88.9008 57.9062 87.7008 57.9062 86.2008V86.0008C57.9062 84.5008 59.1062 83.3008 60.6062 83.3008H192.306C193.806 83.3008 195.006 84.5008 195.006 86.0008V86.2008C195.006 87.7008 193.806 88.9008 192.306 88.9008Z",
    fill: "#0575FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8016 40.4004L99.1016 72.1004C99.1016 74.6004 97.3016 76.7004 95.1016 76.7004L44.0016 77.2004C41.8016 77.2004 39.9016 75.2004 39.9016 72.7004L39.6016 41.0004C39.6016 38.5004 41.4016 36.4004 43.6016 36.4004L94.7016 35.9004C96.9016 35.9004 98.8016 37.9004 98.8016 40.4004Z",
    fill: "#FFF5BD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M98.9031 50.5L99.1031 72.1C99.1031 74.6 97.3031 76.7 95.1031 76.7L44.0031 77.2C41.8031 77.2 39.9031 75.2 39.9031 72.7L39.7031 49L70.7031 66.8L98.9031 50.5Z",
    fill: "#F2AF5C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M39.7031 49.002L59.2031 60.302L39.9031 73.602L39.7031 49.002Z",
    fill: "#ED7E3D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M98.7047 50.7012L80.3047 61.6012L98.9047 72.8012L98.7047 50.7012Z",
    fill: "#ED7E3D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6984 36.4012C81.6984 32.7012 78.5984 30.2012 75.2984 30.2012C73.3984 30.2012 71.6984 31.2012 70.5984 32.8012C69.4984 31.2012 67.7984 30.2012 65.8984 30.2012C62.5984 30.2012 59.8984 33.2012 59.8984 36.9012C59.8984 38.8012 60.5984 40.6012 61.7984 41.8012H61.8984C62.0984 42.0012 62.3984 42.3012 62.6984 42.5012L70.8984 49.7012V49.8012L70.9984 49.7012L71.0984 49.8012C73.6984 47.5012 76.3984 45.5012 78.7984 43.0012C80.0984 41.4012 81.6984 38.9012 81.6984 36.4012Z",
    fill: "#F9A993"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7031 50.7008H27.6031C26.6031 50.7008 25.7031 49.8008 25.7031 48.8008V48.7008C25.7031 47.7008 26.6031 46.8008 27.6031 46.8008H50.7031C51.7031 46.8008 52.6031 47.7008 52.6031 48.7008V48.8008C52.6031 49.9008 51.8031 50.7008 50.7031 50.7008Z",
    fill: "#FFF5BD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8047 60.5016H48.7047C47.7047 60.5016 46.8047 59.6016 46.8047 58.6016V58.5016C46.8047 57.5016 47.7047 56.6016 48.7047 56.6016H71.8047C72.8047 56.6016 73.7047 57.5016 73.7047 58.5016V58.6016C73.7047 59.7016 72.8047 60.5016 71.8047 60.5016Z",
    fill: "#FFF5BD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 60.5016H18.4C17.4 60.5016 16.5 59.6016 16.5 58.6016V58.5016C16.5 57.5016 17.4 56.6016 18.4 56.6016H41.5C42.5 56.6016 43.4 57.5016 43.4 58.5016V58.6016C43.4 59.7016 42.5 60.5016 41.5 60.5016Z",
    fill: "#FFF5BD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7031 51.0012H7.00313C6.30313 51.0012 5.70312 50.4012 5.70312 49.7012V48.5012C5.70312 47.8012 6.30313 47.2012 7.00313 47.2012H17.7031C18.4031 47.2012 19.0031 47.8012 19.0031 48.5012V49.7012C19.1031 50.4012 18.5031 51.0012 17.7031 51.0012Z",
    fill: "#FFF5BD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M143.203 70.6008V8.80078",
    stroke: "#F9A993",
    strokeWidth: 1.8316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M144.305 8.80078V28.0008L164.705 18.4008L144.305 8.80078Z",
    fill: "#F9A993",
    stroke: "#F9A993",
    strokeWidth: 1.8316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M149.205 70C149.205 73 146.905 75.5 144.005 75.5C141.105 75.5 138.805 73 138.805 70C138.805 67 141.105 64.5 144.005 64.5C146.905 64.5 149.205 66.9 149.205 70Z",
    fill: "#F9A993",
    stroke: "#F9A993",
    strokeWidth: 1.8316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M219.102 47.5L219.802 48.8L221.002 49.5L219.802 50.2L219.102 51.5L218.402 50.2L217.102 49.5L218.402 48.8L219.102 47.5Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M172.802 105.1L174.802 108.8L178.502 110.8L174.802 112.9L172.802 116.5L170.802 112.9L167.102 110.8L170.802 108.8L172.802 105.1Z",
    fill: "#DEE1E6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M199.297 116.301L200.197 118.001L201.797 118.801L200.197 119.701L199.297 121.301L198.397 119.701L196.797 118.801L198.397 118.001L199.297 116.301Z",
    fill: "#DEE1E6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M180.397 129.199L181.497 131.199L183.497 132.299L181.497 133.399L180.397 135.499L179.297 133.399L177.297 132.299L179.297 131.199L180.397 129.199Z",
    fill: "#DEE1E6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M211.8 5.09961L214.4 9.79961L219.1 12.2996L214.4 14.8996L211.8 19.5996L209.2 14.8996L204.5 12.2996L209.2 9.79961L211.8 5.09961Z",
    fill: "#DEE1E6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M196.797 20.9004L198.297 23.5004L200.897 24.9004L198.297 26.3004L196.797 28.9004L195.397 26.3004L192.797 24.9004L195.397 23.5004L196.797 20.9004Z",
    fill: "#DEE1E6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4984 0L39.2984 3.3L42.5984 5.10001L39.2984 6.9L37.4984 10.2L35.6984 6.9L32.3984 5.10001L35.6984 3.3L37.4984 0Z",
    fill: "#DEE1E6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5031 18.4004L55.9031 19.2004L56.7031 19.6004L55.9031 20.1004L55.5031 20.9004L55.0031 20.1004L54.2031 19.6004L55.0031 19.2004L55.5031 18.4004Z",
    fill: "#DEE1E6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3031 13.3008L29.0031 18.2008L33.9031 20.9008L29.0031 23.6008L26.3031 28.5008L23.6031 23.6008L18.7031 20.9008L23.6031 18.2008L26.3031 13.3008Z",
    fill: "#DEE1E6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7969 81.5L30.3969 84.4L33.3969 86.1L30.3969 87.7L28.7969 90.6L27.1969 87.7L24.2969 86.1L27.1969 84.4L28.7969 81.5Z",
    fill: "#DEE1E6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8 76.1992L5.09999 78.5992L7.59999 79.9992L5.09999 81.2992L3.8 83.7992L2.5 81.2992L0 79.9992L2.5 78.5992L3.8 76.1992Z",
    fill: "#DEE1E6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6031 96L77.7031 98.2L79.9031 99.3L77.7031 100.5L76.6031 102.7L75.4031 100.5L73.2031 99.3L75.4031 98.2L76.6031 96Z",
    fill: "#DEE1E6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4016 5L93.8016 7.4L96.3016 8.8L93.8016 10.2L92.4016 12.7L91.1016 10.2L88.6016 8.8L91.1016 7.4L92.4016 5Z",
    fill: "#DEE1E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000003161);
export default __webpack_public_path__ + "static/media/Group 1000003161.0f7fbaf1956255049b8c0043381a4a48.svg";
export { ForwardRef as ReactComponent };